import React from 'react';
import { Link } from 'react-router-dom';
import { getValidUrl } from '../helpers/url';

class ProductCard extends React.Component {

  render() {
    const { name, image_ref, product_type } = this.props;
    let imageArray = [];
    let images = image_ref.split(',');

    images.forEach(function (obj) {
      // Check if image ref is full Widen URL and use it. Otherwise, use locally stored images.
      imageArray.push(
        getValidUrl(obj) === true
          ? `${obj.replace(' ', '').replace(/\s+/g, '-').toLowerCase()}`
          : `/wp-content/themes/uniform_base/assets/img/doors/${obj.replace(' ', '').replace(/\s+/g, '-').toLowerCase()}`
      );
    });

    return (
      <div className='col-lg-3 col-md-4 product-wrapper'>
        <Link to={`/products/doors/${name.replace('-', '_').replace(/\s+/g, '-').replace('/', '__').toLowerCase()}`}>
          <div className="product">
            <img src={imageArray[0]} alt={name} className="product__image" />
            <div className="product__body">
              <h3 className="product__type">{product_type}</h3>
              <p className="product__name">{name}</p>
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

export default ProductCard;
